import request from 'utils/header'
const sign_in_email = (email, password, uiVersion) => request.post('/login/new', {email, password, uiVersion})

const sign_in_phone = (phone, mpin, uiVersion) => request.post('/phone', {phone: phone, mpin, uiVersion})

const check_phone = (phone) => request.post('/phone/check', {phone})

const sign_up_phone = (phone, store_id) => request.post('/phone/signup', {phone: phone, company: store_id})

const verify_phone = (_id, code) => request.post(`/phone/verify/${_id}`, {code})

const google_login = () => request.get('/google')

const facebook_login = () => request.get('/facebook')

const sign_out = () => request.post('/signout')

const authenticate_check = (data) => request.post(`/auth/check`, data)

const archived_user_login = (phone, mpin) => request.post(`/auth/archived/login`, { phone, mpin })
const archived_user_login_email = (email, password) => request.post(`/auth/archived/login/email`, { email, password })


const _expObject = {
  google_login,
  authenticate_check,
  facebook_login,
  sign_in_email,
  sign_in_phone,
  check_phone,
  sign_up_phone,
  verify_phone,
  archived_user_login,
  archived_user_login_email,
  sign_out,
}
export default _expObject
